<template>
  <b-container>
    <Breadcrumbs crumbString="View Our Work,Smith Historical Farm"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <p>Historical Walk Interpretive signs<br>
          Palmyra, New York<br>
          Novalloy signs on anodized aluminum pedestals posts</p>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8 image-slider-container">
        <ImageSlider :images="images" class="image-slider"></ImageSlider>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import ImageSlider from '@/components/ImageSlider.vue'

  export default {
    components: {
      Breadcrumbs,
      ImageSlider
    },
    props: {
      images: {
        default: () => [
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs01.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs02.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs03.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs04.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs05.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs06.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs07.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs08.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs09.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs10.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs11.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs12.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs13.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs14.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs15.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs16.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs17.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs18.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs19.jpg'),
          require('@/assets/images/pages/smith-farm/smith-farm-historical-signs20.jpg')
        ],
        type: Array
      }
    },

    data () {
      return {
        title: 'Smith Historical Farm'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/viewOurWork/SmithFarm.vue